import React from 'react';
import Loader from 'react-loader-spinner';

const LoadingPage = () => {
    return (

        <div className="position-fixed bg-dark w-100 h-100 nav justify-content-center align-items-center" style={style} >
            {/* <img className="mb-4" src={appLogo} alt="" width="72" height="72" />
            <h1 className="h3 mb-3 font-weight-normal">Adosac Admin</h1> */}
            <Loader className="mt-4"
                type="ThreeDots"
                color="#fff"
                height={80}
                width={80}
                timeout={0} />
        </div>
    );
}

const style = {
    zIndex: 10000,
}

export default LoadingPage;